import { MAINTENANCE, SLUDGE_EMPTYING, SPANC } from '../utils/rikutec';

const locale = {
    app: {
        actions: {
            refresh: 'Actualizar',
            addItem: 'Crear',
            editItem: 'Editar',
            deleteItem: 'Eliminar',
            title: 'Acciones',
        },
        ancsV2: {
            actions: {
                history: 'Historial',
                forms: 'Formularios',
            },
            subtabs: {
                install: 'Instalación',
                installHint: 'Seguimiento, producto y tipología de suelo',
                coord: 'Datos de contacto',
                coordHint: 'Propietario, lugar, instalador y distribuidor',
                recep: 'Recepción de obras',
                recepHint: 'Acta y estado de las reservas',
            },
            formsTitle: 'trazabilidad',
            signatures: {
                owner: 'Promotor',
                installer: 'Contratista',
                ownerRole: 'propietario',
                installerRole: 'instalador',
                signed: 'Firmada',
                pending: 'Pendiente',
                missing: 'Sin firmar',
                unavailable: 'Firma no disponible',
                others: 'Otras firmas',
            },
            files: {
                title: 'Archivos',
                document: 'Documento',
                step: 'Etapa',
                date: 'Fecha',
                action: 'Acción',
                empty: 'Ningún archivo en el historial',
                error: 'No se pudieron cargar los archivos del historial',
                download: 'Descargar',
            },
            personalData: 'Datos personales',
            process: {
                older: 'Proceso antiguo',
                current: 'Proceso actual',
                both: 'Antiguo y luego actual',
                pose: 'Instalación por el instalador',
                landOwner: 'Instalación por el propietario del terreno',
                commissioning: 'Puesta en servicio por el propietario',
                noForm: 'Ningún formulario en el historial',
            },
            checks: {
                waterRunoff: 'Implantación: aguas de escorrentía desviadas',
                steepSlope: 'Implantación: pendiente pronunciada controlada',
                devicesInWater: 'Implantación: no más de 1,10 m en agua',
                evacuationAndVentilation: 'Implantación: evacuación y ventilaciones conformes',
                noLoadWithin3Meters: 'Implantación: sin carga a menos de 3 m',
                rapidRecovery: 'Implantación: rápida recuperación de la vegetación',
                notInFloodProneArea: 'Implantación: fuera de zona inundable',
                waterDecanter: 'Decantador con agua',
                basketInPlace: 'Cesta colocada en la fosa séptica',
                downstreamLiftingDevice: 'Elevación aguas abajo opcional operativa y segura',
                biologicalWaterReactor: 'Reactor biológico con agua, armario conectado',
                gravityFlow: 'Flujo por gravedad desde la alimentación',
                biologicalFilterVentilation: 'Ventilación del filtro biológico operativa',
                closedAndSecureBuffers: 'Tapas cerradas y aseguradas',
                ownerInformed: 'Propietario informado del funcionamiento',
            },
            groups: {
                information: 'Información',
                tracking: 'Seguimiento',
                product: 'Información del producto',
                client: 'Datos del propietario',
                installation: 'Lugar de instalación',
                installer: 'Datos del instalador',
                distributor: 'Datos del distribuidor',
                soil: 'Tipología de suelo',
                reception: 'Acta de recepción de obras',
                reserves: 'Estado de las reservas',
                signatures: 'Firmas',
                siteChecks: 'Controles de instalación',
            },
            columns: {
                model: 'Modelo',
                lastMaintenance: 'Último mantenimiento',
                lastEmptying: 'Último vaciado',
                processingCapacity: 'Capacidad de procesamiento',
                clientFullName: 'Cliente',
                installerCompany: 'Instalador',
                installationCity: 'Ciudad de instalación',
                readyToDeliverDate: 'Lista para entregar',
                poseDate: 'Fecha de instalación',
                reserveLiftDate: 'Levantar las reservas',
                hasOwnerSignature: 'Firma del promotor',
                hasInstallerSignature: 'Firma del contratista',
            },
            // Wording of the Rikutec process forms (coreapi, RikutecExtBundle CreateProcess* commands).
            forms: {
                loadError: 'No se pudo cargar toda la información de esta instalación',
                notAsked: 'No solicitado por este proceso',
                lastName: 'Apellido',
                firstName: 'Nombre',
                company: 'Empresa',
                address: 'Dirección',
                postalCode: 'Código postal',
                city: 'Ciudad',
                country: 'País',
                email: 'Email',
                phone: 'Teléfono',
                invoiceDate: 'Fecha de instalación o de factura',
                serialNumber: 'Número de serie del producto',
                nominalCapacity: 'Capacidad nominal',
                totalUsefulVolume: 'Volumen útil total',
                sludgeStorageVolume: 'Volumen de almacenamiento de lodos',
                stableBedding: 'Suelo permeable y estable: lecho de asiento',
                stableBackfilling: 'Suelo permeable y estable: relleno lateral',
                impermeableSlab: 'Suelo impermeable: losa de hormigón armado',
                impermeableBedding: 'Suelo impermeable: lecho de hormigón pobre',
                impermeableBackfilling: 'Suelo impermeable: relleno lateral',
                unstableBedding: 'Suelo inestable: lecho de hormigón pobre',
                unstableBackfilling: 'Suelo inestable: relleno lateral',
                quoteNumber: 'Presupuesto n.º',
                workInformation: 'Relativo a las obras',
                withReserve: 'Recepción con reservas',
                conditionsReceived: 'Condiciones de uso y mantenimiento recibidas',
                madeIn: 'Hecho en',
                madeOn: 'El',
                privacyAccepted: 'Política de privacidad aceptada',
                kindOfReserve: 'Naturaleza de las reservas',
                workToBePerformed: 'Trabajos a ejecutar',
                workPeriod: 'Plazo global de ejecución',
                answers: {
                    yes: 'Sí',
                    no: 'No',
                },
                soilOptions: {
                    form8: 'Instalación en suelo permeable, estable y sin agua subterránea',
                    form9: 'Instalación en terreno impermeable o con presencia de agua subterránea',
                    form10: 'Instalación en suelo inestable o poco permeable, sin agua subterránea',
                },
            },
            filters: {
                clientFullName: 'Cliente',
                installerCompany: 'Instalador',
                distributorCompany: 'Distribuidor',
                installationCity: 'Ciudad de instalación',
            },
        },
        ancs: {
            qrScan: {
                button: 'Escanear QR',
                clear: 'Mostrar todos',
                title: 'Escanear el QR de la pieza',
                hint: 'Coloque el QR dentro del marco',
                notFound: 'No se encontró ninguna pieza para este QR',
                searchFailed: 'Error en la búsqueda',
                cameraNotAvailable: 'Cámara no disponible o en uso',
                permissionDenied: 'Acceso a la cámara denegado',
                noCamera: 'No hay cámara accesible',
                selectCamera: 'Cámara',
                camera: 'Cámara',
            },
            departmentFilter: {
                label: 'Departamentos',
                all: 'todos',
                title: 'Haga clic en los departamentos que desea ver',
                selected: 'Seleccionados',
                hint: 'Solo se encuentran las ANC con código postal.',
                clear: 'Borrar todo',
                cancel: 'Cancelar',
                apply: 'Aplicar',
            },

            level1: 'Nivel 1',
            level2: 'Nivel 2',
            level3: 'Nivel 3',
            level4: 'Nivel 4',
            level5: 'Nivel 5',
            postalCode: 'Código postal',
            name: 'Designación',
            articleNumber: 'Código de producto',
            productTypology: 'Tipo de producto',
            serialNumber: 'Número de serie',
            installingDate: 'Fecha de instalación',
            maintenanceLastDate: 'Último mantenimiento',
            sludgeEmptyingLastDate: 'Último vaciado',
            maintenanceThreshold: 'Nivel de mantenimiento',
            sludgeEmptyingThreshold: 'Nivel de vaciado',
            sludgeEmptyingThresholdFilterDate: 'Filtrar por período y evento registrado',
            sludgeEmptyingThresholdFilterLastDate: 'Período por vaciado',
            sludgeMaintenanceThresholdFilterLastDate: 'Período por mantenimiento',
            sludgeEmptyingThresholdOrMaintenanceFilterDate: 'Último vaciado de lodos',
            addFilter: 'Agregar un filtro',
            customize: 'Personalizar',
            refresh: 'Actualizar',
            thresholdName: 'Etiqueta del nivel',
            thresholdMinValue: 'Valor mín.',
            thresholdMaxValue: 'Valor máx.',
            thresholdTriggerValue: 'Valor de activación',
            thresholdMinTriggerValue: 'Límite inferior del intervalo',
            thresholdMaxTriggerValue: 'Límite superior del intervalo',
            thresholdMonthValue: 'Mes',
            addThreshold: 'Agregar un nivel',
            processingCapacity: 'Capacidad de tratamiento',
            sludgeStorageVolume: 'Volumen de almacenamiento de lodos',
            totalUsefulVolume: 'Volumen útil total',
            nodeCurrentState: 'Estado actual',
            nodeStateName: 'Nombre del estado',
            nodeDateOfTakesPlace: 'Fecha del estado actual',
            model: 'Modelo',
            weeks: 'Semanas',
            hours: 'Horas',
            days: 'Días',
            years: 'Años',
            month: 'Mes',
            accessToFinger: 'Vista de campo',
            vueSpecifique: 'Vista específica',
            backofficeForms: 'Llenar formularios',
            backofficeDocuments: 'Enviar documentos',
            backofficeMissingRefresh:
                'No hay sesión (token de actualización). Vuelva a iniciar sesión en el backoffice para abrir la app con su usuario.',
            [MAINTENANCE]: 'Mantenimiento',
            [SLUDGE_EMPTYING]: 'Vaciado',
            [SPANC]: 'Spanc',
            actions: {
                title: 'Acciones',
                managementThresholds: 'Gestión de umbrales',
                defineThresholds:
                    'Lista de niveles de alerta, según los intervalos de tiempo desde la última operación',
                export: 'Exportar',
                statistics: 'Estadísticas',
                refresh: 'Actualizar',
                personalize: 'Personalizar',
                editVP: 'Agregar / Editar un acta',
                editWC: 'Agregar / Editar un certificado de garantía',
                mapAvatars: 'ANC geolocalizados',
                realTimeMonitoring: 'Seguimiento de ANC',
                scheduledMonitoring: 'Seguimiento de ANC',
                productTypology: 'Tipo de producto',
                types: 'Tipo',
                thresholds: 'Configuración de umbrales',
            },
            error: {
                server: 'Ocurrió un error. Contacte al administrador',
                wrongMinAmount: 'Monto mínimo incorrecto',
                wrongMaxAmount: 'Monto máximo incorrecto',
                requiredField: 'Campo obligatorio',
                minMustExceedPreviousMax: 'El valor debe ser mayor que el máximo anterior',
                maxMustExceedPreviousMin: 'El valor debe ser mayor que el mínimo anterior',
                greaterThanZero: 'No puede ser negativo',
            },
            metadataAvatarType: {
                name: 'Nombre del tipo de producto',
            },
            help_text: {
                once_validated:
                    'Una vez validado, para ver el documento enviado haga clic en el botón de la columna «Vista de campo»',
            },
            success: {
                success: 'Los datos se guardaron',
                media_uploaded: 'El medio seleccionado se cargó',
                media_updated: 'El medio seleccionado se actualizó',
            },
        },
        button: {
            confirm: 'Validar',
            submit: 'Enviar',
            cancel: 'Cancelar',
            go: {
                toThresholdPage: 'Ver los umbrales',
                toAncsPage: 'Ver los ANC',
            },
        },
        common: {
            after: 'Después',
            before: 'Antes',
            loading: 'Cargando, espere por favor',
            loadingMapData: 'Cargando los datos del mapa...',
            page: 'Página',
            of: 'de',
            loaded: 'Cargado',
            items: 'elementos',
            requests: 'Solicitudes',
            remaining: 'restantes',
        },
        dashboard: {
            title: 'Panel',
            creationObjet: 'Creación de objetos',
            subtitle: 'Objetos creados en el periodo',
            granularity: {
                hours: 'Hora',
                day: 'Día',
                month: 'Mes',
            },
            period: {
                menu: 'Período',
                lastWeek: 'Última semana',
                lastMonth: 'Último mes',
                lastYear: 'Último año',
            },
            dateFrom: 'Desde',
            dateTo: 'Hasta',
            groups: {
                label: 'Grupos de objetos',
                title: 'Seleccionar grupos de objetos',
                name: 'Nombre',
                none: 'Todos los grupos',
            },
            error: 'No se pudo cargar el gráfico',
        },
        errors: {
            updatingProperty: 'Ocurrió un error al actualizar una propiedad',
            creatingProperty: 'Ocurrió un error al crear una propiedad',
            updatingType: 'Ocurrió un error al actualizar un tipo',
            creatingType: 'Ocurrió un error al crear un tipo',
            gettingLanguage: 'Ocurrió un error al obtener el idioma de la propiedad',
            languages: 'Ocurrió un error al obtener los idiomas',
        },
        headers: {
            eyebrow: {
                overview: 'Vista general',
                realTime: 'Seguimiento de instalaciones · tiempo real',
                every2Hours: 'Seguimiento de instalaciones · actualizado cada 2 horas',
                reference: 'Referencial y administración',
            },
            description: 'Descripción',
            additional_info: 'Información adicional',
            info: 'Información',
            type: 'Tipo',
            types: 'Tipo',
            selectAvatarTypeGroup: 'Seleccione el tipo de producto',
            confirmDelete: 'Eliminar',
            productTypeData: 'Datos del tipo de producto',
            productType: 'Tipo de producto',
            ancs: 'Seguimiento de ANC',
            thresholds: 'Configuración de umbrales',
        },
        mc: {
            add: 'Agregar',
            application: 'Aplicación',
            changePict: 'Cambiar el ícono',
            copy: 'Copiar la URL',
            creationDate: {
                afterFilter: 'Después',
                beforeFilter: 'Antes',
                value: 'Fecha de creación',
            },
            downloadQrcode: 'Descargar el código QR',
            edit: 'Editar',
            editDialogTitle: 'Editar el MC',
            enabled: {
                no: 'No',
                yes: 'Sí',
            },
            exportQrcode: 'Exportar el código QR',
            general: 'General',
            identification: 'Identificación del módulo de comunicación',
            information: 'Información',
            mcName: 'Nombrar los módulos de comunicación',
            name: 'Nombre',
            parameter: 'Parámetro « MC »',
            remove: 'Eliminar',
            showQrcode: 'Ver el código QR',
            visitApp: 'Abrir la aplicación',
            yourls: {
                shortUrl: 'URL corta',
            },
        },
        medias: {
            addApproval: 'Agregar homologación',
            addTechnicalSheet: 'Agregar la ficha técnica',
            addRoutineMaintenance: 'Agregar el mantenimiento de rutina',
            addUserGuide: 'Agregar la guía de uso y mantenimiento',
            addInstallingGuide: 'Agregar la guía de instalación',
            mediaFile: 'Cargar un archivo',
            addReflexEmptying: 'Agregar la Ficha Reflex de vaciado',
            addReflexMaintenance: 'Agregar la Ficha Reflex de mantenimiento',
            addUserBooklet: 'Agregar el manual del usuario',
        },
        messages: {
            confirmDelete: '¿Desea eliminar esta línea?',
            confirmOperation: 'Está a punto de eliminar un elemento. ¿Seguro que desea continuar?',
            canSendApprovalLater: 'Puede enviar la homologación más tarde',
            loading: 'Cargando, espere por favor',
            error: 'Algo salió mal, avise al administrador',
            success: 'La operación se realizó correctamente',
        },
        no: 'No',
        objects: {
            by: 'Por',
            noNotes: 'Sin notas',
            details: 'Detalles',
            notes: 'Notas',
            description: 'Descripción',
            mc: 'Módulos de comunicación',
            service: 'Servicio',
            qrCode: 'Código QR',
            info: {
                name: 'Nombre del objeto',
                type: 'Tipo de objeto',
                description: 'Descripción',
                reference: 'Referencia',
                created: 'Fecha de creación',
                enterprise: 'Empresa',
                images: 'Imágenes',
                audios: 'Audios',
                documents: 'Documentos',
                signatures: 'Firmas',
                externalIdentification: 'Identificación externa',
                forms: 'Formularios',
                gps: 'GPS',
                filter: {
                    filter: 'Filtro',
                    name: 'Nombre',
                    note: 'Nota',
                    traceability: 'Trazabilidad',
                },
            },
            filters: {
                avatarProperties: {
                    additionalInformation: 'Información adicional',
                },
            },
            infoTab: 'Información',
        },
        objects2: {
            _date: 'Fecha de creación',
            actions: {
                additionalInformation: 'Información adicional',
                changeTraceability: 'Cambiar la trazabilidad',
                changeWebApp: 'Cambiar la aplicación web',
                deleteAction: {
                    keepMcsName: 'Eliminar y conservar el módulo de comunicación',
                    name: 'Eliminar',
                },
                simulateWebApp: 'Simular la aplicación web',
            },
            addImages: 'Haga clic aquí para agregar imágenes',
            addObject: 'Agregar un objeto',
            additionalInformation: {
                actions: {
                    addNewName: 'Nuevo nombre',
                    addProperty: 'Agregar una propiedad',
                    createGSTemplate: 'Crear una plantilla G-Sheet',
                    editProperty: 'Editar la propiedad',
                    hidePrivate: 'Ocultar las propiedades privadas',
                    importDataGS: 'Importar los datos de G-Sheet',
                    importDataTypeObject: 'Importar un dato del tipo de objeto',
                    showPrivate: 'Mostrar las propiedades privadas',
                },
                addProperty: {
                    finish: 'Finalizar',
                    helpText:
                        'Defina la información adicional. La opción de visualización permite definir si la información es accesible sin contraseña desde las aplicaciones web móviles compatibles (contáctenos para más información). La definición permite agrupar informaciones entre sí.',
                },
                creator: 'Creador',
                definition: 'Nombre de la definición (la definición permite agrupar informaciones entre sí)',
                error: {
                    addColumnsData: 'Ocurrió un error al agregar columnas en la hoja SC-DATA',
                    addDataTypes: 'Ocurrió un error al agregar columnas en la hoja SC-DATA-TYPE',
                    addSheets: 'Verifique que el G-Sheet no contenga datos',
                    googleSheetLine: 'El número de línea debe ser mayor que uno',
                    noData: 'No hay datos disponibles.',
                    noValue: 'Valor indefinido',
                    properties: 'Debe agregar al menos una propiedad',
                    spreadsheet: 'Ocurrió un error al importar los datos de la hoja de cálculo',
                    spreadsheetURL: 'La URL debe ser una hoja de cálculo',
                },
                fieldType: 'Tipo de información',
                fieldTypeOptions: {
                    boolean: 'Booleano (« sí » o « no »)',
                    date: 'Fecha',
                    number: 'Número',
                    string: 'Texto',
                },
                googleSheetURL: 'URL de G-Sheet',
                helpText: {
                    additionalInformation: 'Configure la información adicional que desea registrar sobre su objeto',
                    createSpreadsheetsTemplate: 'Configure las propiedades que desea generar en su archivo G-Sheet',
                    definition: 'La definición permite agrupar informaciones entre sí.',
                    fieldType:
                        'El tipo de información es un parámetro que puede usarse en funcionalidades de terceros o en una aplicación móvil compatible (contáctenos para más información).',
                    googleSheet:
                        'Para importar datos desde un archivo G-Sheet, asegúrese de que el formato de los datos sea compatible',
                    googleSheetLine: 'Debe escribir el número de línea a importar.',
                    googleSheetURL: 'Inserte el enlace para compartir del archivo G-Sheet.',
                    name: 'Defina el título de la información adicional',
                    private:
                        'La opción de visualización define si la información es accesible sin contraseña desde las aplicaciones web móviles compatibles (contáctenos para más información).',
                    spreadsheetCreate: 'La plantilla G-Sheet se creó',
                    unit: 'Unidad',
                },
                lineNumber: 'Elección del número de línea',
                lineToImport: 'Elección del número de línea (ejemplo « 1-4 »)',
                name: 'Título de la información',
                private: 'Regla de visualización',
                privateOptions: {
                    private:
                        'Privado: el dato de la información se cifrará y solo será visible cuando se identifique un usuario con permisos.',
                    public: 'Público: la información será visible sin necesidad de identificarse con una cuenta desde las aplicaciones web que usan la información adicional del objeto.',
                },
                title: 'Información adicional',
                tooltipActionIcons: {
                    edit: 'Editar',
                    private: 'Información privada',
                    remove: 'Eliminar',
                    required: 'Información obligatoria',
                },
                unit: 'Unidad',
                value: 'Valor (datos) de la información',
            },
            alphaId: 'Referencia',
            applications: 'Servicio de redirecciones',
            bulk_action: {
                addToObjectGroup: 'Agrupar',
                addTraceability: 'Trazabilidad',
                changeFinger: 'Redirección',
                error: {
                    diferentCompany:
                        'Verifique que todos los objetos pertenezcan a la misma cuenta del grupo de objetos %{object_group_name}',
                    headerTable: 'Error',
                    notAdded: 'El objeto no se agregó al grupo',
                    notChangeApp: 'La redirección no se modificó',
                    notChangeTraceability: 'La trazabilidad no se modificó',
                    notRemoveFromGroup: 'El objeto no se quitó del grupo',
                    title: 'Algunos objetos no se actualizaron',
                    titleUpdateMCs: 'El MC no se actualizó',
                },
                removeToObjectGroup: 'Desagrupar',
                titleAddToGroup: 'Elija un grupo de objetos para actualizar los objetos seleccionados',
                titleAddTraceability:
                    'Elija el proceso de trazabilidad que quiere cambiar. Tenga en cuenta que el cambio solo funciona si el objeto usa una aplicación web que utiliza trazabilidad (ej.: MemoTagPro)',
                titleChangeFinger: 'Elija una redirección para actualizar los objetos seleccionados',
                titleChangeFingerForMC: 'Elija una redirección para actualizar el MC',
                titleRemoveGroup: 'Elija el grupo que desea desvincular del objeto seleccionado',
            },
            createModal: {
                p1text1: 'Para registrar o agregar un objeto en la plataforma, debe usar la',
                p1text2: 'aplicación móvil de emparejamiento',
                p1text3: ' en el ',
                p1text4: 'objeto real',
                p1text5: ' que integra uno o varios módulos de comunicación de tipo NFC o código QR.',
                p2text1: 'Para más información contacte al ',
                p2text2: 'soporte',
            },
            createObject: {
                advancedForm: 'Formulario avanzado',
                error: {
                    addToGroup: 'No fue posible agregar el objeto al grupo de objetos',
                    createMc: 'No se pudo crear el MC',
                    simulateMc: 'No se realizó la simulación de los MC',
                },
                finger: {
                    add: 'Agregar redirecciones',
                },
                groupObjects: {
                    add: 'Grupo de objetos',
                },
                helpText: {
                    chooseTypeObject: 'Elija su tipo de objeto para preconfigurar su nuevo objeto:',
                    createObject:
                        'Está a punto de crear un objeto manualmente. Existe una forma más optimizada de crear un objeto, para eso consulte esta página',
                    createObjectPage: 'Cómo crear un objeto',
                },
                notification: {
                    addToGroup: 'El objeto se agregó al grupo',
                    copied: 'Copiado al portapapeles',
                },
                simplifiedForm: 'Formulario simplificado',
                title: 'Crear un objeto',
                validatePrevData: 'Valide los datos precargados',
            },
            createObjectMultiple: {
                errors: {
                    emptyLine: 'Ocurrió un problema. Una línea sin valor',
                    nogapi: 'No fue posible acceder a la API de Google. Contacte al administrador del servicio.',
                    notFoundDataInTableInSpreadsheet: 'La %{table} no tiene datos',
                    notFoundPropertyInTable: 'La propiedad %{property} no está en la tabla %{table}',
                    notFoundTableInSpreadsheet: 'La %{table} no está en la hoja de cálculo',
                    readLine: 'Los números de línea a importar no tienen datos',
                    spreadsheet: 'Ocurrió un error al importar los datos de la hoja de cálculo',
                },
                helpText: {
                    amount: 'Cantidad de objetos a crear',
                    step1CreateObject: 'Cómo crear un objeto',
                    step1Part1:
                        'Está a punto de crear un objeto manualmente. Existe una forma más optimizada de crear un objeto, para eso vea esta página',
                    step1Part2: 'Elija su tipo de objeto para preconfigurar su nuevo objeto',
                    step2ValidatePreFillData: 'Valide estos datos precargados',
                    step3Line1:
                        'Para importar los datos de un archivo G-Sheet, asegúrese de que el formato de los datos sea compatible.',
                    step3Line2: 'Inserte el enlace para compartir del archivo G-Sheet.',
                    step3Line3:
                        'Debe elegir el número de línea a importar, de la primera a la última línea separadas por un guion, por ejemplo « 2-6 ».',
                    step3Line4: 'Las siguientes líneas se crearán como objeto:',
                    withFile: 'Creación con una tabla G-Sheet:',
                    withoutFile: 'Sin archivo',
                },
                title: 'Crear varios objetos',
            },
            currentStateName: 'Estado',
            date: 'Fecha de creación',
            dateTitle: 'Fecha de creación:',
            deleteModal: '¿Seguro que desea archivar los elementos seleccionados?',
            deleteModalAlways: '¿Seguro que desea eliminar los elementos seleccionados?',
            deleteModalNotCancel: '¿Seguro que desea eliminar el elemento seleccionado?',
            deploy: 'Desplegar',
            description: 'Descripción',
            documents: 'Documentos',
            editObject: {
                add: {
                    mc: {
                        added: 'El módulo de comunicación se agregó',
                        error: 'El módulo de comunicación no se agregó',
                        title: 'Agregar un módulo de comunicación al objeto',
                    },
                },
                title: 'Editar el objeto',
            },
            export: {
                historic: {
                    csv: 'Historial (CSV)',
                    xlsx: 'Historial (XLSX)',
                },
                objects: {
                    csv: 'Inventario (CSV)',
                    xlsx: 'Inventario (XLSX)',
                },
            },
            filters: {
                avatarProperties: {
                    additionalInformation: 'Información adicional',
                    definitionInput: 'IA - Clasificación',
                    definitionLabel: 'Información adicional - Clasificación',
                    nameInput: 'IA - Nombre',
                    nameLabel: 'Información adicional - Nombre',
                    valueInput: 'IA - Valor',
                    valueLabel: 'Información adicional - Valor',
                },
                business: 'Negocio',
                creationDate: 'Fecha de creación',
                creationDateAfter: 'Fecha de creación - Después',
                creationDateBefore: 'Fecha de creación - Antes',
                factory: 'Planta',
                historyCreated: 'Fecha del historial',
                historyCreatedAtAfter: 'Fecha del historial - Después',
                historyCreatedAtBefore: 'Fecha del historial - Antes',
                history_name: 'Nombre del estado',
                metadataAvatarType: 'Tipo de objeto',
                objectGroup: 'Grupo de objetos',
                objectName: 'Nombre del objeto',
                parent: 'Objeto padre',
                shortUrl: 'URL corta',
                site: 'Obra',
                typeObject: 'Nombre del tipo de objeto',
            },
            finger: 'Finger',
            generate: {
                create_from_file: 'Crear MC a partir de un archivo',
                simulate: 'Simular',
            },
            groupObjects: 'Grupo de objetos',
            historic: 'Historial',
            info: {
                additionalAddress: 'Complemento de dirección',
                address: 'Dirección',
                altitude: 'Altitud',
                amountNotes: 'Cantidad de notas',
                attachDocuments: 'Agregar documentos',
                attachImage: 'Cargar una imagen',
                attachImages: 'Agregar imágenes',
                attachOneImage: 'Agregar una imagen',
                chooseRootObjectType: 'Elija el tipo de objeto raíz',
                city: 'Ciudad',
                country: 'País',
                created: 'Fecha de creación',
                createdAt: 'Fecha de creación',
                description: 'Descripción',
                enabled: 'Activo',
                enabledDate: 'Fecha de activación',
                enterprise: 'Empresa',
                extradata: 'Datos adicionales',
                extradata_infos: {
                    dimension: 'Dimensión',
                    empty_: 'Abra el Finger (WebApp) para consultar la información o contacte al administrador para personalizarla',
                    profession_data: 'Datos del negocio',
                },
                filter: {
                    apply: 'Aplicar como filtro',
                    avatarGroup: 'Grupo de objetos',
                    company: 'Empresa',
                    history_created_at: {
                        afterFilter: 'Fecha del historial - Después',
                        beforeFilter: 'Fecha del historial - Antes',
                        value: 'Fecha del historial',
                    },
                    metadataAvatarType: 'Tipo de objeto',
                    name: 'Filtro',
                    note: 'Notas',
                    traceability: 'Trazabilidad',
                },
                groupAvatar: {
                    name: 'Grupos',
                },
                id: 'Id',
                image: 'Imagen',
                images: 'Imágenes',
                inputMap: 'Haga clic en el texto para mostrar el mapa',
                lastNote: 'Última nota',
                latitude: 'Latitud',
                localization: 'Ubicación',
                longitude: 'Longitud',
                mcs: 'Módulos de comunicación',
                name: 'Nombre del objeto',
                nature: 'Tipo de MC',
                parent: 'Objeto padre',
                position: 'Posición del objeto',
                postalCode: 'Código postal',
                redirectTo: {
                    show: {
                        company: 'Mostrar en la página de la empresa',
                        metadataAvatarType: 'Mostrar en la página del tipo de objeto',
                    },
                },
                reference: 'Referencia',
                showImages: 'Mostrar todas las imágenes',
                stateObject: 'Estado del objeto',
                statistics: 'Estadísticas',
                statistics_redirection: {
                    title: 'Estadísticas detalladas del objeto',
                },
                street: 'Calle',
                tracking: {
                    _date_state: 'Fecha del estado',
                    currentNode: 'Nodo actual',
                    date_state: 'Fecha del estado',
                    fullName: 'Nombre y apellido',
                    goNext: 'Siguiente',
                    goPrevious: 'Anterior',
                    name_state: 'Estado',
                    selectNode: 'Seleccione un nodo',
                    title: 'Seguimiento',
                },
                type: 'Tipo de objeto',
            },
            information: 'Información',
            interfaces: 'Interfaz',
            list: {
                actions: {
                    customize_list: 'Personalizar',
                },
            },
            location: 'Ubicación',
            mc: 'Módulos de comunicación',
            moduleCommunications: 'Módulos de comunicación',
            name: 'Nombre',
            nameObject: 'Nombre del objeto',
            nature: {
                nfc: 'NFC',
                qrcode: 'Código QR',
                st25: 'ST25',
            },
            notDefined: 'No definido',
            notSelected: 'No hay ningún objeto seleccionado',
            object: 'Objeto',
            objectMenu: {
                title: 'Elija un objeto',
            },
            objectType: 'Tipo de objeto',
            objects: 'Objetos',
            openHistory: 'Abrir el historial',
            photoObject: 'Foto del objeto',
            quantityMCs: 'Cantidad de módulos',
            service: 'Nombre del servicio de redirección',
            tabs: {
                mc: 'STOCK NO EMPAREJADO DE MÓDULOS DE COMUNICACIÓN',
            },
            type: 'Tipo de objeto',
            typeObject: {
                applicationDisponibles: 'Servicios de redirección disponibles',
            },
            typesObjects: 'Tipos de objetos',
            url: 'Url',
            webServiceDisplay: 'Servicio web a mostrar',
        },
        productType: {
            create: 'Crear',
            edit: 'Editar',
            name: 'Tipo de producto',
            yes: 'Sí',
            no: 'No',
            approval: 'Homologación',
            approvalFile: 'Cargar un archivo de homologación',
            mediaFile: 'Cargar un archivo',
            addApproval: 'Agregar homologación',
            editApproval: 'Editar homologación',
            addItem: 'Crear',
            editItem: 'Editar',
            deleteItem: 'Eliminar',
            messages: {
                success: 'Los datos se guardaron',
                error: 'Ocurrió un error',
            },
            success: {
                updated: 'El tipo de producto se actualizó',
            },
            error: {
                server: 'Ocurrió un error. Contacte al administrador',
            },
        },
        sidebar: {
            anc: 'Seguimiento de ANC',
            appName: 'Backoffice ANC',
            realTimeShort: 'tiempo real',
            every2HoursShort: 'cada 2 h',
            sections: {
                monitoring: 'Seguimiento',
                reference: 'Referencial',
            },
            every2Hours: 'Actualización cada 2 horas',
            realTime: 'Actualización en tiempo real',
            product_type: 'Tipo de producto',
            type: 'Tipo',
            threshold_settings: 'Configuración de umbrales',
            disconnect: 'Cerrar sesión',
        },
        prestataires: {
            title: 'Mis Prestadores',
            menu: 'Mis Prestadores',
            columns: {
                companyName: 'Empresa',
                types: 'Tipo(s)',
                departments: 'Departamentos',
                email: 'Email',
                actions: 'Acciones',
            },
            list: {
                empty: 'Aún no hay prestadores afiliados.',
                summary: '%{companies} empresa(s) prestadora(s)',
            },
            actions: {
                add: 'Añadir un prestador',
                refresh: 'Actualizar',
                cancel: 'Cancelar',
                back: 'Atrás',
                next: 'Siguiente',
                link: 'Vincular',
                submit: 'Guardar',
                save: 'Guardar',
                edit: 'Editar',
                unlink: 'Desvincular',
                viewPdf: 'Ver documento de homologación',
                createAndLink: 'Crear',
            },
            fields: {
                types: 'Tipos de prestación',
                departments: 'Departamentos',
                departmentsHelp: 'Haga clic en los departamentos del mapa o busque una dirección',
                departmentsForType: 'Departamentos — %{type}',
                addressSearch: 'Buscar una dirección (IGN)',
                departmentsMapHelp: 'Haga clic en un departamento para añadirlo o quitarlo. La dirección de la empresa preselecciona su departamento.',
                departmentSearch: 'Añadir un departamento (código o nombre)',
                copyDepartmentsFrom: 'Copiar departamentos de…',
                clearDepartments: 'Borrar todo',
                email: 'Email del prestador',
                companyName: 'Razón social',
                siret: 'SIRET',
                adminEmail: 'Email admin',
                adminPassword: 'Contraseña admin',
                adminName: 'Nombre admin',
                adminLastName: 'Apellido admin',
                street: 'Dirección',
                additionalAddress: 'Complemento de dirección',
                postalCode: 'Código postal',
                city: 'Ciudad',
                country: 'País',
            },
            types: {
                MISE_EN_SERVICE: 'Puesta en servicio',
                ENTRETIEN: 'Mantenimiento',
                REPARATION: 'Reparación',
            },
            wizard: {
                title: 'Añadir un prestador',
                steps: {
                    siret: 'SIRET',
                    details: 'Información',
                    company: 'Empresa',
                    zone: 'Zona de intervención',
                },
                siretHelp: 'Introduzca el SIRET de la empresa: comprobamos si ya existe en el sistema.',
                choosePdf: 'Elegir un PDF',
                found: 'Empresa ya presente en el sistema',
                foundHelp: 'Se vinculará a su cuenta, no es necesario volver a crearla. Indique sus tipos de prestación y departamentos.',
                notFound: 'Ninguna empresa con el SIRET %{siret} en el sistema',
                alreadyAffiliated: '%{name} ya está afiliada a su cuenta.',
                notEligible: '%{name} existe en el sistema pero no es instalador, mantenedor ni vaciador: no puede ser afiliada.',
                companyBlock: 'Información de la empresa',
                adminBlock: 'Administrador de la cuenta',
                annuairePrefilled: 'Prerrellenados desde el Annuaire des Entreprises, revíselos antes de guardar.',
                annuaireClosed: 'Atención: este establecimiento está cerrado según el Annuaire des Entreprises.',
                siretDigits: '%{count}/14 dígitos',
                createHelp: 'Complete sus datos: se crearán la empresa y su cuenta de administrador.',
                adminHelp: 'Esta cuenta permitirá al proveedor conectarse a la aplicación.',
                adminEmailIsLogin: 'Servirá como usuario de conexión',
                generatePassword: 'Generar una contraseña segura',
                showPassword: 'Mostrar la contraseña',
                hidePassword: 'Ocultar la contraseña',
                zoneHelp: 'Elija los servicios que realiza %{name} y, para cada uno, los departamentos cubiertos.',
            },
            zone: {
                title: 'Zona de intervención por servicio',
                recenter: 'Volver a centrar en Francia',
                legendActive: 'Servicio actual',
                legendOther: 'Otros servicios',
                addRegion: 'Añadir / quitar una región',
                applyToAll: 'Aplicar a todos los servicios',
                selectedCount: '%{smart_count} departamento seleccionado |||| %{smart_count} departamentos seleccionados',
                emptySelection: 'Ningún departamento. Haga clic en el mapa, busque un departamento o añada una región.',
                pickTypeFirst: 'Seleccione al menos un tipo de servicio para definir su zona de intervención.',
            },
            edit: {
                title: 'Editar afiliación',
                replacePdf: 'Reemplazar documento de homologación (opcional)',
                addPdf: 'Añadir documento de homologación (opcional)',
                replacePdfHelp: 'Deje vacío para conservar el documento actual.',
            },
            validation: {
                typesRequired: 'Seleccione al menos un tipo',
                departmentsRequired: 'Indique al menos un departamento válido',
                departmentsRequiredForType: 'Seleccione al menos un departamento para %{type}',
                siretInvalid: 'El SIRET debe contener 14 dígitos',
                required: 'Campo obligatorio',
                emailInvalid: 'Dirección de email no válida',
            },
            messages: {
                createSuccess: 'Prestador añadido correctamente',
                updateSuccess: 'Afiliación actualizada',
                unlinkSuccess: 'Afiliación desvinculada',
                confirmUnlink: '¿Desvincular este prestador?',
                pdfUnavailable: 'Sin documento de homologación',
                missingCompany: 'Empresa fabricante no encontrada',
                error: 'Se ha producido un error',
            },
        },
        login: {
            heroTitle: 'Seguimiento de instalaciones de saneamiento autónomo',
            heroText: 'De la entrega a la puesta en servicio: trazabilidad, firmas y documentos de cada instalación.',
            title: 'Iniciar sesión',
            subtitle: 'Inicie sesión con su usuario y contraseña.',
            username: 'Usuario',
            password: 'Contraseña',
            submit: 'Iniciar sesión',
            error: 'Usuario o contraseña incorrectos',
        },
        pwa: {
            info: 'Info',
            title: 'Agregar a la pantalla de inicio',
            intro: 'Puede acceder a la aplicación como una app desde su teléfono.',
            close: 'Cerrar',
            qr: {
                title: 'Abrir en el celular',
                hint: 'Escanee este código con la cámara de su teléfono para abrir el backoffice.',
            },
            install: {
                title: 'Instalar la aplicación',
                message: 'Agregue Rikutec a su pantalla de inicio para acceder directamente, como una app nativa.',
                action: 'Instalar',
                later: 'Más tarde',
            },
            android: {
                title: 'Android (Chrome)',
                step1: 'Abra el sitio en Chrome.',
                step2: 'Toque el menú ⋮ en la esquina superior derecha.',
                step3: 'Seleccione «Agregar a pantalla de inicio» o «Instalar aplicación».',
            },
            ios: {
                title: 'iOS (Safari)',
                step1: 'Abra el sitio en Safari.',
                step2: 'Toque el botón Compartir en la parte inferior de la pantalla.',
                step3: 'Seleccione «Agregar a inicio» y confirme.',
            },
        },
        traceabilityNotesThreshold: {
            name: 'Umbral',
            operationType: 'Tipo de operación',
            objectType: 'Tipo de producto',
            activeEvent: 'Evento activo',
            deleted: 'El umbral se eliminó correctamente',
            actions: {
                title: 'Acciones',
                addEvent: 'Agregar un umbral',
                deleteEvent: 'Eliminar un umbral',
                editEvent: 'Editar el umbral seleccionado',
                managementThresholds: 'Gestión de umbrales',
                defineThresholds:
                    'Lista de niveles de alerta, según los intervalos de tiempo desde la última operación',
                export: 'Exportar',
                statistics: 'Estadísticas',
                refresh: 'Actualizar',
                personalize: 'Personalizar',
                delete: {
                    title: '¿Eliminar el umbral?',
                    message: '¿Seguro que desea eliminar el umbral?',
                },
            },
            error: {
                server: 'Ocurrió un error. Contacte al administrador',
                uniqueMetadataAvatarType: 'Existe una notificación vinculada a este tipo de objeto',
                set: {
                    groupAvatar: 'Debe definirse el grupo del objeto',
                    avatar: 'Debe definirse el objeto',
                    metadataAvatarType: 'Debe definirse el tipo de objeto',
                },
            },
            maintenance: {
                name: 'Umbral de mantenimiento',
            },
            emptying: {
                name: 'Umbral de vaciado',
            },
        },
        types: {
            productName: 'Designación',
            productType: 'Tipo de producto',
            alpha_id: 'Alpha Id',
            id: 'Id',
            name: 'Nombre del tipo',
            processingCapacity: 'Capacidad de tratamiento',
            sludgeStorageVolume: 'Volumen destinado al almacenamiento de lodos',
            totalUsefulVolume: 'Volumen útil total',
            model: 'Modelo',
            itemCode: 'Código de artículo',
            typeSerialNumber: 'Primeros 4 dígitos del número de serie',
            create: 'Crear tipo',
            edit: 'Editar',
            empty: '<vacío>',
            addEditInstallingGuide: 'Agregar / Editar la guía de instalación',
            addEditinstalling_guide: 'Agregar / Editar la guía de instalación',
            installing_guide: 'Guía de instalación',
            user_booklet: 'Manual del usuario',
            mediaFile: 'Cargar un archivo',
            user_guide: 'Guía de uso y mantenimiento',
            reflex_emtying: 'Ficha Reflex de vaciado',
            reflex_maintenance: 'Ficha Reflex de mantenimiento',
            technical_sheet: 'Ficha técnica',
            routine_maintenance: 'Mantenimiento de rutina',
            addReflexEmtying: 'Agregar la Ficha Reflex de vaciado',
            addReflexMaintenance: 'Agregar la Ficha Reflex de mantenimiento',
            addInstallingGuide: 'Agregar la guía de instalación',
            addUserGuide: 'Agregar la guía de uso y mantenimiento',
            addUserBooklet: 'Agregar el manual del usuario',
            enableApproval: 'Activar la homologación',
            disableApproval: 'Desactivar la homologación',
            approvalEnabled: 'Homologación activada',
            approvalDisabled: 'Homologación desactivada',
            addTechnicalSheet: 'Agregar la ficha técnica',
            addRoutineMaintenance: 'Agregar el mantenimiento de rutina',
            addEditUserGuide: 'Agregar / Editar la guía de uso',
            addEdituser_guide: 'Agregar / Editar la guía de uso',
            addEditTechnicalSheet: 'Agregar / Editar la ficha técnica',
            addEdittechnical_sheet: 'Agregar / Editar la ficha técnica',
            addEditRoutineMaintenance: 'Agregar / Editar el mantenimiento de rutina',
            addEditroutine_maintenance: 'Agregar / Editar el mantenimiento de rutina',
            yes: 'Sí',
            no: 'No',
            messages: {
                success: 'Los datos se guardaron',
                error: 'Ocurrió un error',
            },
        },
        notification: {
            copied: 'Copiado correctamente',
        },
        download: 'Descargar',
        validation: {
            required: 'Campo obligatorio',
        },
        yes: 'Sí',
    },
};

// Traducciones añadidas para el módulo de notas
// Se extiende el objeto existente sin reordenarlo
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(locale.app as any).notes = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...(locale.app as any).notes,
    makeBy: 'Hecho por',
    formsDialog: 'Formularios',
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(locale.app as any).main_buttons = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...(locale.app as any).main_buttons,
    actions: 'Acciones',
    back: 'Volver',
    create: 'Crear',
    delete: 'Eliminar',
    edit: 'Editar',
    next: 'Siguiente',
    openForms: 'Abrir formularios',
    return: 'Volver',
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(locale.app as any).objects = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...(locale.app as any).objects,
    documents: 'Documentos',
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(locale.app as any).signs = 'Firmas';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(locale.app as any).rikutec = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...(locale.app as any).rikutec,
    externalIdentification: {
        label: 'Identificación externa',
        name: 'Nombre',
        email: 'Correo electrónico',
    },
};

export default locale;
